// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"e054b02e","358":"6650f475","930":"82e4c4a3","947":"6dadd418"}[chunkId] + ".chunk.js";
};